/** Calendar days, independent of the browser timezone and daylight saving. */
export function remainingPaymentDueDate(eventDate: string | null | undefined): string {
  if (!eventDate || !/^\d{4}-\d{2}-\d{2}$/.test(eventDate)) return "";
  const date = new Date(`${eventDate}T00:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== eventDate) return "";
  date.setUTCDate(date.getUTCDate() - 14);
  return date.toISOString().slice(0, 10);
}
